import { NotificationTheme } from '../../../constants/notification';

export enum NotificationPlacement {
  MODAL = 'MODAL',
  GLOBAL = 'GLOBAL',
}

interface NotificationWithMessage {
  id?: string;
  theme?: NotificationTheme;
  show?: boolean;
  size?: 'small' | 'big';
  type?: 'global' | 'local' | 'sticky';
  message: string;
  placement?: NotificationPlacement;
}

interface NotificationWithKey {
  id?: string;
  theme?: NotificationTheme;
  show?: boolean;
  size?: 'small' | 'big';
  type?: 'global' | 'local' | 'sticky';
  key: string;
  options?: {
    [key: string]: string;
  };
  placement?: NotificationPlacement;
}

export type NotificationModel = NotificationWithMessage | NotificationWithKey;

export const isNotificationWithKey = (
  notification: NotificationModel,
): notification is NotificationWithKey =>
  (notification as NotificationWithKey).key !== undefined;
